import * as React from 'react'
import { copyObject, randomId } from "../../../utils";
import { CompanyT, ListOfVariablesStrings, VariablesObj, VariablesT, VariableT, WorkerTypeTStrings } from '../../../types/Company';

import moment, { Moment } from 'moment'

import * as _ from 'lodash'
import { getVariableValue } from './DocumentsTab/DocumentVariables';

import { formatDate, formatDateToUtc, parseFloatTotal } from '../../../utils/utilsT';
import { JobWorkerT } from '../../../types/JobWorker';
import { ActivityT, EstimateLineItemT, JobT, LocationT, RevenueLineItemT } from '../../../types/Job';
import { TransactionT } from '../../../types/TransactionT';
import { getDirections } from '../../../utils/MapboxClient';
import { getDistance } from '../../../utils/helperMaps';
import { CargoPrintT, CupeSheetPrintT, CargoT } from '../../../types/CargoT';
import config from '../../../constants/config';
import { getPinJobA } from '../PinMarkerJobs';
export interface LineItemFinancialT {
  item?: string
  total?: number
  lineItemDate?: string
  [key: string]: any
}
/**
 *
 * @param job
 * @returns
 */
export const getMinimumTime = (job: JobT) => {
  let minimumTime = 0
  if (job?.companyInfo && _.has(job.companyInfo, "variables.minimumTime")) {
    minimumTime = Number(job?.companyInfo?.variables?.minimumTime?.value)
  }
  return minimumTime <= 0 ? 1 : minimumTime;
}

/**
 *
 * @param companyVariables
 * @param variable
 * @param isRate
 * @returns
 */
export const reflectorLabel = (companyVariables: VariablesT, variable: VariableT, isRate: boolean = true) => {
  let strLable = isRate ? variable.rateLabel : variable.unitsLabel
  // search <key> if exists in rateLabel or unitsLabel
  const regex = /[<][a-z-A-Z]+[>]/g;
  let match = regex.exec(strLable)
  if (_.isArray(match) && match[0]) {
    let strMatch = String(match[0]).replace('<', '').replace('>', '');
    if (companyVariables[strMatch]) {
      // replace value for  related key by regex
      return strLable.replace(regex, companyVariables[strMatch].value)
    }
  }
  return isRate ? variable.rateLabel : variable.unitsLabel;
}

//  resolveUnitLabel
export const resolveUnitLabel = (companyVariables: VariablesT, item: string, isRate: boolean = true): string => {
  // console.log("companyVariables",companyVariables)
  if (companyVariables[item]) {
    let label = `${reflectorLabel(companyVariables, companyVariables[item], isRate)}`
    return label != "" ? `, ${label}` : ""
  }
  return '';
}


const resolveDurationTime = (time): Moment => {
  const today = moment()
  const _time = moment(time).format("HH:mm")
  return moment(`${today.clone().format("YYYY-MM-DD")} ${_time}`, "YYYY-MM-DD HH:mm")
}

/**
 *
 * @param job
 * @return hours number
 */
export const getJobDuration = (job: JobT): number => {
  let duration = 0;
  let activitiesIsDirty = false;
  const locations = _.isArray(job.locations) ? job.locations : []

  locations.map((location, index) => {
    const activities: Array<ActivityT> = _.isArray(location.activities) ? location.activities : []
    activities.map((activity, index) => {
      if (activity.startTime && activity.startTime != '' && activity.endTime && activity.endTime != '') {
        // we can get amoutn from activities
        activitiesIsDirty = true
        let startTime = resolveDurationTime(activity.startTime)
        let endTime = resolveDurationTime(activity.endTime)
        let between = endTime.diff(startTime, "seconds")
        console.log("between", between)
        if (between > 0) {
          // add +1 because function diff return minues 1
          between = between + 1
          duration += (between / 60) / 60
        }
      }
    })
  })

  // const companyVariables = { ...job.companyInfo.variables, ...VariablesObj }
  let minimumTime
  if (job?.companyInfo?.variables == null || job?.companyInfo?.variables?.minimumTime == null) {
    minimumTime = ''
  } else {
    minimumTime = Number(job?.companyInfo?.variables?.minimumTime?.value)
  }
  return duration > minimumTime ? _.round(duration) : minimumTime;
}

/**
 *
 * @param job
 * @return Array<EstimateLineItemT>
 */
export const prepareJobAmount = (job: JobT) => {
  // jobAmount = (number of workers) * rate * minimum time
  let duration = 0;
  let numWorkers = job.crew.length;
  let lineItems = getVariableValue('lineItems', job.documents.estimate.variables)
  lineItems = lineItems ? lineItems : []


  let estimates = []
  const defaultVariableLocal = ['hourlyRateOne', 'hourlyRateTwo', 'hourlyRateThree', 'hourlyRateFour']
  const schame = {
    estimate: {
      variables: ['estimate']
    },
    load: {
      variables: ['hourlyRateOne', 'hourlyRateTwo', 'hourlyRateThree', 'hourlyRateFour']
    },
    unload: {
      variables: ['hourlyRateOne', 'hourlyRateTwo', 'hourlyRateThree', 'hourlyRateFour']
    },
    pack: {
      variables: ['hourlyRateOnePacking', 'hourlyRateTwoPacking', 'hourlyRateThreePacking', 'hourlyRateFourPacking']
    }
  }

  const companyVariables = { ...job?.companyInfo?.variables, ...VariablesObj }
  let minimumTime = getMinimumTime(job)
  const locations = _.isArray(job.locations) ? job.locations : []
  // const activities = getActivitiesInvoice(locations)
  console.log("companyVariables->job.companyInfo.variables", job.companyInfo.variables)
  console.log("companyVariables", companyVariables)

  let activitiesIsDirty = false

  locations.map((location, index) => {
    const activities: Array<ActivityT> = _.isArray(location.activities) ? location.activities : []


    activities.map((activity, index) => {
      let durationLine = 0
      let durationInfo = null;
      if (activity.startTime && activity.startTime != '' && activity.endTime && activity.endTime != '') {
        // we can get amoutn from activities
        activitiesIsDirty = true
        let startTime = moment(activity.startTime).utc()
        let endTime = moment(activity.endTime).utc()
        durationInfo = moment.duration(endTime.diff(startTime));
        let between = endTime.diff(startTime, "seconds")
        if (between > 0) {
          // add +1 because function diff return minues 1
          between = between + 1
          duration += between
          durationLine = between
        }

      }

      if (schame[activity.activityType] && numWorkers <= 4 && durationInfo) {

        let variable = schame[activity.activityType].variables[numWorkers - 1]

        let hours = durationInfo.hours() <= minimumTime ? minimumTime : durationInfo.hours()

        if (companyVariables[variable]) {
          let lineItemEstiamte: EstimateLineItemT = {
            id: activity.id,
            item: variable,
            lineItemDate: activity.activityDate,
            rate: companyVariables[variable].value,
            total: parseFloat(companyVariables[variable].value) * parseFloat(hours),
            units: hours,
            isAutoFill: true,
          }
          // estimates.push({})
          estimates.push(lineItemEstiamte)
        }
      }
    })
  })

  // console.log("minimumTime",minimumTime)
  // console.log("numWorkers",numWorkers)
  if (!activitiesIsDirty && numWorkers <= 4) {
    let variableRate = defaultVariableLocal[numWorkers - 1]
    if (companyVariables[variableRate]) {
      let lineItemEstiamte: EstimateLineItemT = {
        id: null,
        item: variableRate,
        lineItemDate: null,
        rate: companyVariables[variableRate].value,
        total: parseFloat(companyVariables[variableRate].value) * parseFloat(`${minimumTime}`),
        units: minimumTime,
        isAutoFill: true,
      }
      estimates.push(lineItemEstiamte)
    }
  }
  // console.log("activitiesIsDirty", activitiesIsDirty)
  // console.log("estimates", estimates)
  return estimates
}


/**
 *  calculating  automatically job payments by locations->activities or estimate
 * @param job
 * @param company
 * @return total:number
 */
export const getJobAmount = (job: JobT): number => {
  const company = job.companyInfo
  let estimateDirty = getVariableValue('dirty', job.documents.estimate.variables)
  let estimates = []
  if (!estimateDirty) {
    estimates = prepareJobAmount(job)
  } else {
    let variables = job.documents.estimate && job.documents.estimate.variables ? job.documents.estimate.variables : []
    let lineItems = getVariableValue('lineItems', job.documents.estimate.variables)

    estimates = lineItems ? lineItems : []
    // estimates = prepareJobAmount(job, company)
  }
  // console.log("estimateDirty", estimateDirty)
  // console.log("estimates", estimates)

  const total = sumFinancialLineItems(copyObject(estimates))
  return total

}

/**
 *
 * @param job
 * @returns
 */
export const extractImpliedLineDate = (job: JobT, format = "h:mm A on MMM DD, YYYY", isLocal: boolean = false): string | null => {
  /**
   * swtich to jobDate
   */
  if (hasJobDate(job)) {
    if (moment(job?.jobDate).isValid()) {
      return isLocal ? formatDate(job?.jobDate, format, isLocal) : moment(job?.jobDate).toDate().toString()
    } else {
      return null
    }
  }

  if (_.isArray(job.locations) && job.locations.length > 0 && _.isArray(job.locations[0].activities) && job.locations[0].activities.length > 0) {

    return moment(job.locations[0].activities[0].activityDate).isValid() ? moment(job.locations[0].activities[0].activityDate).toDate().toString() : null
  }
  else return null
}



export const hasJobDate = (job: JobT): boolean => {
  // const dateSwitched = moment(config.dateSwitched).format("MM/DD/YYYY")
  // const dateAdded = moment(job?.date)
  // return dateAdded.isAfter(dateSwitched) ? true : false
  return job?.jobDate && job?.jobDate != "" && job?.jobDate != "0000-00-00 00:00:00" ? true : false
}
/**
  *
  * @param job
  * @returns
  */
export const extractStartTime = (job: JobT): string | null => {
  if (_.isArray(job.locations) && job.locations.length > 0 && _.isArray(job.locations[0].activities) && job.locations[0].activities.length > 0) {

    return moment(job.locations[0].activities[0].startTime).isValid() ? moment(job.locations[0].activities[0].startTime).toDate().toString() : null
  }
  else return null
}



/**
 *
 * @param job
 * @param workerId
 */
export const workerIsExistsInCrew = (job: JobT, workerId): boolean => {
  const crew = job.crew && _.isArray(job.crew) ? job.crew : []
  const find = crew.find((x) => x.id == workerId)

  return find ? true : false
}




/**
 *
 * @param job
 * @param format
 * @returns
 */
export const getJobMoveDate = (job: JobT, format = "h:mm A on MMM DD, YYYY", isLocal: boolean = false): string => {

  let moveDate = ""
  try {

    const activityDate = extractImpliedLineDate(job, format, isLocal)
    if (hasJobDate(job)) {
      return activityDate
    }
    const startTime = extractStartTime(job)
    let activityDateFormat = activityDate ? moment(activityDate).format('MM/DD/YYYY') : ""

    if (startTime) {
      moveDate = activityDateFormat != "" ? formatDate(`${activityDateFormat} ${moment(startTime).format('h:mm A')}`, format, isLocal) : ""
    } else {
      moveDate = activityDateFormat != "" ? formatDate(`${activityDateFormat}`, format, isLocal) : ""
    }
  } catch (error) {

  }
  // return moveDate;
  return moveDate
}

export const getDipslayNameForClient = (firstname: string = "", lastname: string = "") => {

}


/**
 *
 * @param job
 * @returns
 */
export const getVariablesCompanyByjob = (job: JobT): VariablesT => {
  const variables = { ...VariablesObj, ...job.companyInfo.variables }
  return variables
}
/**
 *
 * @param variables
 * @returns
 */
export const parseVariables = (variables: VariablesT): VariablesT => {
  const result = { ...VariablesObj, ...variables }
  return result
}

/**
 *
 * @param job
 * @returns
 */
export const getWorkerFlatPay = (job: JobT): number => {
  const variables = getVariablesCompanyByjob(job)
  const workerFlatPay = Number(parseFloat(`${variables.workerFlatPay.value}`).toFixed(2))
  return workerFlatPay
}

/**
 *
 * @param job
 * @returns
 */
export const getWorkerPay = (job: JobT): number => {
  const variables = getVariablesCompanyByjob(job)
  const workerFlatPay = Number(parseFloat(`${variables.workerPay.value}`).toFixed(2))
  return workerFlatPay
}


/**
 *
 * @param job
 * @returns
 */
export const extractVariable = (variables: VariablesT, key: ListOfVariablesStrings): VariableT | null => {
  const result = parseVariables(variables)
  if (_.has(result, key)) {
    return result[key]
  }
  return null
}
// export const getMinimumTime = (job: JobT): number => {
//     const variables = getVariablesCompanyByjob(job)
//     const minimumTime = Number(parseFloat(`${variables.minimumTime.value}`).toFixed(2))
//     return minimumTime
// }



export const convertItemByWorker = (worker: JobWorkerT, item: WorkerTypeTStrings, indexCrew: number) => {
  let name = `${worker.firstName} ${worker.lastName}`
  let variableName = name == ' ' ? `worker${indexCrew + 1}` : _.camelCase(name)
  let id = worker.id != 0 ? worker.id : `worker${indexCrew + 1}`
  let result = {
    key: `${item}<${id}><${indexCrew}>`,
    variableName: variableName,
  }
  return result;
}


/**
 *
 * @param transactions
 * @returns
 */
export const getRevenueFromTrasactions = (revenueItems: Array<RevenueLineItemT>, transactions: Array<TransactionT>) => {
  let items = []

  if (!Array.isArray(transactions) || transactions.length === 0) return items;

  const generateRevenueLineItem = (item, id, itemName: string, date) => {
    // const units = item.productUnits ? item.productUnits : 1
    let lineItem: RevenueLineItemT = {
      id: id,
      item: itemName,
      date: date,
      rate: item.productRate > 0 ? item.productRate : item.amount,
      units: item.productUnits ? item.productUnits : 1,
      total: item.amount,
      isDirty: true,
    }

    return lineItem
  }


  transactions.map((item, index) => {

    if (_.has(item, "lineItems") && _.isArray(item.lineItems)) {
      item.lineItems.map((lineItem) => {
        items.push(generateRevenueLineItem(lineItem, lineItem.productItemId, lineItem.productItem, item.date))
      })

    } else {
      const id = item.productItemId ? item.productItemId as string : item.paymentId as string;
      const find = revenueItems.find((x) => x.id == id)
      if (find) {
        return null
      }
      items.push(generateRevenueLineItem(item, id, item.paymentType, item.date))
    }


  })
  return items;

}



export const revenueExistInTransactions = (revenueLineItem: RevenueLineItemT, transactions: Array<TransactionT>) => {
  if (!Array.isArray(transactions) || transactions.length === 0) return false;

  let findItem = transactions.find((item) => {
    if (_.has(item, "lineItems") && _.isArray(item.lineItems) && item.lineItems.find((x) => x.productItemId == revenueLineItem.id)) {

      return item
    } else if (transactions.find((x) => x.paymentId == revenueLineItem.id)) {
      return item
    }
    return undefined
  })
  // console.log("findItem", findItem)

  return findItem ? findItem : false

}

export const jobIsLocal = async (job: JobT) => {
  const companyVariables = { ...job.companyInfo.variables, ...VariablesObj }
  const locations = _.has(job, "locations") && _.isArray(job.locations) ? job.locations : []
  if (locations.length <= 1) {
    return true
  }
  const stateIsLocal = locationsStateIsLocal(job.locations)
  if (!stateIsLocal) {
    return false
  }
  let distance = await parseDistance(job.locations)

  if (distance > companyVariables.localIntrastateMargin.value) {
    return false
  }

  return true
}


/**
 *
 * @param locations
 * @returns
 */
export const locationsStateIsLocal = (locations: Array<LocationT>): boolean => {
  let findLocation = locations.find((loction, index) => {
    return locations.find((item) => {
      return item.addressState != loction.addressState
    })
  })
  return !findLocation ? true : false
}


/**
    *
    * @param locations
    * @returns
    */
export const parseDistance = async (locations: Array<LocationT>): Promise<number> => {
  let distance = 0
  try {

    if (locations.length > 2) {
      let result = await getDirections(locations)
      distance = result.distanceMailes
    } else if (locations.length == 2) {
      distance = getDistance(locations[0], locations[1])
    }
  } catch (error) {
    console.log("error", error)
  }
  return distance
}

export type CategoryCupeSheetT = {
  [key in string]: Array<CargoT>
}

export const sortItemsCupeSheetByCategory = (lineItems: Array<CargoT>): CategoryCupeSheetT => {
  let categories = {}
  lineItems.map((item, index) => {
    if (!_.has(categories, item.category)) {
      categories[item.category] = lineItems.filter((x) => x.category == item.category)
    }
  })
  return categories
}

export const prepareCupeSheetForPrint = (lineItems: Array<CargoT>): Array<CupeSheetPrintT> => {
  let categories = []
  const prepareItems = (items: Array<CargoT>): Array<CargoPrintT> => {
    return items.map((item, index) => {
      const total = Number(item.volume) * Number(item.units)
      return {
        ...item, ...{
          total: total,
          pounds: Number(total) * 7,
        }
      }
    })
  }


  lineItems.map((item, index) => {
    if (!_.has(categories, item.category)) {
      const items = prepareItems(lineItems.filter((x) => x.category == item.category))
      categories.push({
        category: item.category,
        items: items,
        total: sumFinancialLineItems(_.cloneDeep(items))
      })
    }
  })
  return categories
}


export const workerPayIsLaborFlat = (job: JobT): boolean => {
  return job?.companyInfo?.defaultWorkerPay == "laborFlat" ? true : false
}




export const sortFinancialLineItems = (items: Array<LineItemFinancialT>): Array<LineItemFinancialT> => {
  return _.sortBy(items,
    [
      function (o) {
        return formatDate(o?.lineItemDate, "MM/DD/YYYY");
      }
    ])
}


export const sumFinancialLineItems = (lis: Array<LineItemFinancialT>): number => {
  if (lis.length == 0) return 0
  let lineItem = lis.shift()
  let total = 0
  if (lineItem?.item == 'discount') total = sumFinancialLineItems(lis) - Number(parseFloat(`${lineItem?.total}`).toFixed(2))
  else total = Number(parseFloat(`${lineItem.total}`).toFixed(2)) + sumFinancialLineItems(lis)
  return parseFloat(`${parseFloatTotal(total)}`)
}

export const getMarkers = (jobClone: JobT): Array<any> => {
  let resultMarkers: Array<any> = []
  if (jobClone.locations.length > 0) {
    jobClone.locations.map((location, index) => {
      const pinJob = getPinJobA(jobClone.jobStatus, jobClone.jobType, extractImpliedLineDate(jobClone), index)
      let marker = {
        coordinate: {
          latitude: Number(location.latitude),
          longitude: Number(location.longitude),
        },
        bgImage: pinJob.ImageJobStatus,
        pinImage: pinJob.ImageJobType,
        bgColor: pinJob.bgColor,
        id: index,
      }
      resultMarkers.push(marker)
    })
  }
  return resultMarkers
}